import { render } from "./trumpetTemplate.vue?vue&type=template&id=390261dc&scoped=true"
import script from "./trumpetTemplate.vue?vue&type=script&lang=js"
export * from "./trumpetTemplate.vue?vue&type=script&lang=js"

import "./trumpetTemplate.vue?vue&type=style&index=0&id=390261dc&scoped=true&lang=css"
import "./trumpetTemplate.vue?vue&type=style&index=1&id=390261dc&lang=css"
script.render = render
script.__scopeId = "data-v-390261dc"

export default script